var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSectionBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 339,
    viewBox: "0 0 1920 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-299.781 152.783L-223.109 133.279C-146.438 113.776 6.90565 74.7691 161.858 66.71C316.811 58.6508 473.374 81.5392 629.936 104.428C786.499 127.316 943.061 150.204 1099.09 162.777C1255.11 175.349 1410.6 177.606 1564.48 148.915C1718.36 120.224 1870.63 60.5859 1946.77 30.7668L2022.9 0.947571L2034.17 217.58L1956.69 221.61C1879.22 225.639 1724.26 233.699 1569.31 241.758C1414.36 249.817 1259.4 257.876 1104.45 265.935C949.499 273.994 794.547 282.054 639.594 290.113C484.641 298.172 329.688 306.231 174.735 314.29C19.7824 322.349 -135.17 330.409 -212.647 334.438L-290.123 338.468L-299.781 152.783Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionBorder);
export default __webpack_public_path__ + "static/media/section-border.5859bf7fadeb8d3935735cef5c6ce2eb.svg";
export { ForwardRef as ReactComponent };